export const SOCKET_INIT = 'init';
export const SOCKET_RECONNECT = 'inCall';
export const SOCKET_REFRESH = 'refresh';

export const METRIC_COLLECTION_INTERVAL = 10 * 1000; // 10 seconds
export const COLLECT_METRICS = false; // Flag to enable/disable stats collection
